import { useDispatch, useSelector } from 'react-redux';

import { RootState } from 'app/appStore';
import { clearReadNotifications, setReadNotifications } from 'entities/Notification';

export const useNotificationsSlice = () => {
	const dispatch = useDispatch();

	return {
		...useSelector((s: RootState) => s.notificationsSlice),
		setReadNotifications: (notifications: number[]) => dispatch(setReadNotifications(notifications)),
		setOpenedOffer: () => dispatch(clearReadNotifications()),
	};
};
